import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { TCCPCommonService } from '../../services/tccp-common.service';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { environment } from '../../../../environments/environment';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-first-setup',
  templateUrl: './first-setup.component.html',
  styleUrls: ['./first-setup.component.scss']
})
export class FirstSetupComponent implements OnInit {
  public envName = '';
  public isInternal = false;
  public windowWidth = window.innerWidth;
  public appName = environment.applicationName;
  public convertedAppName = '';
  public guideImage1: Array<string> = [];
  public guideImage2: Array<string> = [];
  public guideImage3: Array<string> = [];
  public guideImage4: Array<string> = [];
  public guideImage5: Array<string> = [];
  public guideImage6: Array<string> = [];
  public guideImage7: Array<string> = [];
  public guideImage8: Array<string> = [];
  public guideImage9: Array<string> = [];
  public detectedProfileImage: Array<string> = [];
  public carouselSlides: Array<string> = [];
  public imagePath: string = TCCPConstantValues[environment.applicationName].Urls.IMAGE_PATH;
  constructor(private commonService: TCCPCommonService, private renderer: Renderer2, private dialog: MatDialog) { }

  ngOnInit() {
    this.envName = window.location.href;
    this.commonService.hideModelYearSection.emit(true);
    this.isInternal = this.envName.includes('internal');
    this.appName = this.appName === TCCPConstantValues.base.url_contexts.TOYOTA_QUICKGUIDE || this.appName === 'toyota' ?
      'toyota' : 'lexus';
    this.guideImage1 = [`${this.imagePath}content/${this.appName}/common/step-1.png`];
    this.guideImage2 = [`${this.imagePath}content/${this.appName}/common/step-2.png`];
    this.guideImage3 = [`${this.imagePath}content/${this.appName}/common/step-3.png`];
    this.guideImage4 = [`${this.imagePath}content/${this.appName}/common/step-4.png`];
    this.guideImage5 = [`${this.imagePath}content/${this.appName}/common/step-5.png`];
    this.guideImage6 = [`${this.imagePath}content/${this.appName}/common/step-6.png`];
    this.guideImage7 = [`${this.imagePath}content/${this.appName}/common/step-7.png`];
    this.guideImage8 = [`${this.imagePath}content/${this.appName}/common/step-8.png`];
    this.guideImage9 = [`${this.imagePath}content/${this.appName}/common/success-step.png`];
    this.detectedProfileImage = [`${this.imagePath}content/${this.appName}/common/detected-profile.png`];
    this.convertedAppName = this.appName.charAt(0).toUpperCase() + environment.applicationName.slice(1);
    this.commonService.setBackground(this.renderer, this.appName);
  }

  goToMultimedia() {
    const el = document.querySelector('.first-guide-media-content');
    window.scrollTo(0, document.querySelector('.first-guide-content').scrollHeight);
    el.scrollIntoView();
  }

  openDisclaimerDialog(id) {
    this.commonService.getDisclaimer(id).subscribe(data => {
      const disclaimer = data[0].disclaimer.disclaimerId + '. ' + data[0].disclaimer.disclaimerMessage;
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '900px',
        data: { type: 'disclaimer', title: data[0].disclaimer.disclaimerTitle, message: disclaimer },
        position: { top: '150px' },
        id: this.appName + '_disclaimer_popup'
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    });
  }

  openGuideDialog(): void {
    const dialogRef = this.dialog.open(FirstSetupDialogComponent, {
      width: this.windowWidth && this.windowWidth > 768 ? this.windowWidth > 1800 ? '65vw' : '75vw' : '85vw',
      data: { title: this.convertedAppName },
      position: { top: '50px' },
      id: this.appName + '-first-setup-popup'
    });
  }
}

@Component({
  selector: 'app-first-setup-dialog-component',
  templateUrl: './first-setup-dialog.html',
  styleUrls: ['./first-setup.component.scss']
})

export class FirstSetupDialogComponent implements OnInit {
  public appName: string = environment.applicationName;
  public guide = this.data;
  public windowWidth = window.innerWidth;
  public imagePath: string = TCCPConstantValues[environment.applicationName].Urls.IMAGE_PATH;
  public navigationImage = [`${this.imagePath}content/${this.appName}/common/guide-navigation.png`];
  public guestModedImage = [`${this.imagePath}content/${this.appName}/common/guest-mode.png`];
  constructor(
    public commonService: TCCPCommonService,
    public dialogRef: MatDialogRef<FirstSetupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog) {
  }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }
}

